import { useContext } from 'react';
import { ApplicationContext as DAContext } from 'src/features/device-activation/context/application-context';
import { ApplicationContext } from 'src/features/order';

export function useApplication() {
  const daContext = useContext(DAContext);
  const context = useContext(ApplicationContext);

  if (!daContext && !Object.keys(context).length) {
    throw new Error('Revamp: useApplication should be used inside the ApplicationProvider.');
  }

  return daContext || context;
}
